module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-100.4124805c0503dbfe42dd67d7f5715964.woff2";